import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/rh/collaborateurs")({
  loader: async () => {
    // Parent /rh already enforces requireHRManagementAccess
    // This layout route just inherits from parent
  },
  staticData: {
    permission: PERMISSIONS.RH.PERSONNE.VIEW,
  },
  component: () => <Outlet />,
});
